import { render, staticRenderFns } from "./Cakes.vue?vue&type=template&id=44a7db7c&"
import script from "./Cakes.vue?vue&type=script&lang=js&"
export * from "./Cakes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports